import { Reveal } from "@/components/Reveal";
import { GoldDivider } from "@/components/GoldDivider";
import { MoonPhases } from "@/components/MoonPhases";
import { useLang } from "@/i18n";

const GALLERY = [
    { src: "/images/shop/san-miguel.jpg", alt: "Estatua de San Miguel Arcángel en la tienda" },
    { src: "/images/shop/aceites.jpg", alt: "Vitrina de aceites y productos espirituales" },
    { src: "/images/shop/velas-pasillo.jpg", alt: "Pasillo de velas y estatuas religiosas" },
    { src: "/images/shop/interior.jpg", alt: "Interior de Yerberia Jardin D'Venuz en Phoenix" },
];

export const About = () => {
    const { t } = useLang();

    return (
        <section id="nosotros" data-testid="about-section" className="relative py-24 sm:py-32 px-5 sm:px-8 bg-ink">
            <div className="max-w-6xl mx-auto">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
                    <Reveal>
                        <div className="relative ornament-frame border border-gold/20 rounded-sm overflow-hidden">
                            <img
                                src="/images/shop/cristales.jpg"
                                alt="Mesa de cristales, amatistas y esferas en Yerberia Jardin D'Venuz"
                                className="w-full h-80 sm:h-[26rem] object-cover"
                                loading="lazy"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-transparent to-transparent" aria-hidden="true" />
                        </div>
                    </Reveal>
                    <Reveal delay={0.12}>
                        <MoonPhases size={11} className="mb-6" />
                        <h2 className="font-display font-semibold gold-text text-4xl sm:text-5xl tracking-wide leading-tight">
                            {t("about.title")}
                        </h2>
                        <GoldDivider className="my-7 !justify-start" />
                        <p className="text-sm sm:text-base text-cream/70 font-light leading-relaxed">
                            {t("about.p1")}
                        </p>
                        <p className="text-sm sm:text-base text-cream/70 font-light leading-relaxed mt-5">
                            {t("about.p2")}
                        </p>
                        <p className="text-sm sm:text-base text-cream/70 font-light leading-relaxed mt-5">
                            {t("about.p3")}
                        </p>
                        <p className="text-xs text-sand font-light leading-relaxed mt-6 border-l border-gold/30 pl-4">
                            {t("about.disclaimer")}
                        </p>
                    </Reveal>
                </div>

                <Reveal delay={0.1} className="mt-16">
                    <p className="font-accent text-[10px] tracking-[0.3em] uppercase text-gold-soft text-center mb-6">
                        {t("about.galleryLabel")}
                    </p>
                    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3" data-testid="about-gallery">
                        {GALLERY.map((g, i) => (
                            <div key={i} className="group relative aspect-[4/5] overflow-hidden border border-gold/15 rounded-sm hover:border-gold/40 hover:shadow-[0_0_20px_rgba(212,175,55,0.15)] transition-[border-color,box-shadow] duration-300">
                                <img
                                    src={g.src}
                                    alt={g.alt}
                                    loading="lazy"
                                    className="w-full h-full object-cover opacity-85 group-hover:opacity-100 group-hover:scale-105 transition-[opacity,transform] duration-500"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-ink/50 via-transparent to-transparent pointer-events-none" aria-hidden="true" />
                            </div>
                        ))}
                    </div>
                </Reveal>
            </div>
        </section>
    );
};
